import { chains } from '../../chains/chainMetadata';
import { MS_PER_DAY } from '../../constants';
import type { ChainId } from '../../types';
import { selectHardforkForTimestamp } from '../selectHardforkForTimestamp';

export const getBlockTimeByChainId = ({
  chainId,
  targetTimestamp = new Date().getTime(),
}: { chainId: ChainId; targetTimestamp?: number }) => {
  const targetChain = chains[chainId];
  if (!Array.isArray(targetChain.hardforks)) return undefined;

  const blockTime = selectHardforkForTimestamp({
    hardforks: targetChain.hardforks,
    timestamp: targetTimestamp,
  });
  if (!blockTime) return undefined;

  const { blockTimeMs, startTimestamp } = blockTime;

  return {
    startTimestamp,
    blockTimeMs,
    blocksPerDay: blockTime.blockTimeMs !== 0 ? MS_PER_DAY / blockTime.blockTimeMs : 0,
  };
};
